import { Routes } from '@angular/router';

import { SettingsInstruction } from '../builder/instructions/settings/settings.instruction';
import { CityRepositoryInstruction } from '../builder/instructions/repositories/city.repository.instructions';
import { AuthRepositoryInstruction } from '../builder/instructions/repositories/auth.repository.instructions';
import { GetCityByIdentityServiceInstruction } from '../builder/instructions/services/get-city-by-identity.service.instruction';

import { cityResolver } from './utils/city.resolver';

import { SelectCityComponent } from './pages/select-city/select-city.component';
import { MainLayoutComponent } from './layouts/main-layout/main.layout.component';

import { CreateAccountComponent } from './pages/create-account/create-account.component';
import { SelectAccountTypeComponent } from './pages/select-account-type/select-account-type.component';
import { CreateAccountPjComponent } from './pages/create-account-pj/create-account-pj.component';
import { AccountOptionsComponent } from './pages/account-options/account-options.component';
import { CompanyRegistrationComponent } from './pages/company-registration/company-registration.component';

import { AppHandler } from './app.handler';
import { LoginByFormComponent } from './pages/login-by-form/login-by-form.component';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';
import { TwoFactorAuthenticationComponent } from './pages/two-factor-authentication/two-factor-authentication.component';
import { LoginByIcpComponent } from './pages/login-by-icp/login-by-icp.component';
import { LoginIntegrationComponent } from './pages/login-integration/login-integration.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { CompleteRegistrationComponent } from './pages/complete-registration/complete-registration.component';
import { RegistrationCompletionComponent } from './pages/registration-completion/registration-completion.component';
import { LoginByAuthorizationCodeComponent } from './pages/login-by-authorization-code/login-by-authorization-code.component';
import { AccountConfirmationComponent } from './pages/account-confirmation/account-confirmation.component';
import { PylonComponent } from './pages/pylon/pylon.component';
import { SsoComponent } from './pages/sso/sso.component';

export const routes: Routes = [
  {
    path: '',
    component: SelectCityComponent,
  },
  {
    path: 'pylon',
    component: PylonComponent,
  },
  {
    path: 'sso',
    component: SsoComponent,
  },
  {
    path: 'accountConfirmation/:token/:userId',
    component: MainLayoutComponent,
    providers: [
      AppHandler,
      new SettingsInstruction(),
      new CityRepositoryInstruction(),
      // APR-2964: o cityResolver consulta a connection dinâmica (shadow) via AuthRepository
      new AuthRepositoryInstruction(),
      new GetCityByIdentityServiceInstruction(),
    ],
    resolve: {
      city: cityResolver,
    },
    children: [
      {
        path: '',
        component: AccountConfirmationComponent,
      },
    ],
  },
  {
    path: 'account-confirmation/:token/:userId',
    component: MainLayoutComponent,
    providers: [
      AppHandler,
      new SettingsInstruction(),
      new CityRepositoryInstruction(),
      // APR-2964: o cityResolver consulta a connection dinâmica (shadow) via AuthRepository
      new AuthRepositoryInstruction(),
      new GetCityByIdentityServiceInstruction(),
    ],
    resolve: {
      city: cityResolver,
    },
    children: [
      {
        path: '',
        component: AccountConfirmationComponent,
      },
    ],
  },
  {
    path: ':city',
    component: MainLayoutComponent,
    providers: [
      AppHandler,
      new SettingsInstruction(),
      new CityRepositoryInstruction(),
      // APR-2964: o cityResolver consulta a connection dinâmica (shadow) via AuthRepository
      new AuthRepositoryInstruction(),
      new GetCityByIdentityServiceInstruction(),
    ],
    resolve: {
      city: cityResolver,
    },
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        component: LoginByFormComponent,
      },
      {
        path: 'recover-password',
        component: RecoverPasswordComponent,
      },
      {
        path: 'two-factor-authentication',
        component: TwoFactorAuthenticationComponent,
      },
      {
        path: 'icp',
        component: LoginByIcpComponent,
      },
      {
        path: 'callback',
        component: LoginIntegrationComponent,
      },
      {
        path: 'callback/:type/:code',
        component: LoginIntegrationComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
      {
        path: 'create-account',
        component: CreateAccountComponent,
      },
      {
        path: 'select-account-type',
        component: SelectAccountTypeComponent,
      },
      {
        path: 'company-registration',
        component: CompanyRegistrationComponent,
      },
      {
        path: 'account-options',
        component: AccountOptionsComponent,
      },
      {
        path: 'create-account-pj',
        component: CreateAccountPjComponent,
      },
      {
        path: 'accountConfirmation/:token/:userId',
        component: AccountConfirmationComponent,
      },
      {
        path: 'account-confirmation/:token/:userId',
        component: AccountConfirmationComponent,
      },
      {
        path: 'complete-registration',
        component: CompleteRegistrationComponent,
      },
      {
        path: 'registration-completion',
        component: RegistrationCompletionComponent,
      },
      {
        path: 'authorization-code',
        component: LoginByAuthorizationCodeComponent,
      },
    ],
  },
];
